import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import MovementReportService from '_services/movement-report-service';

export const fetchMovementSheet = createAsyncThunk(
  'movementSheet/fetch',
  async (params, { signal }) => {
    return await MovementReportService.getMovementReport(
      { ...params, includeMovementSheet: true },
      signal
    );
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const movementSheetSlice = createSlice({
  name: 'movementSheet',
  initialState,
  reducers: {
    resetMovementSheet: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMovementSheet.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchMovementSheet.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchMovementSheet.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const selectMovementSheetData = (state) => state.movementSheet.data;
export const selectMovementSheetStatus = (state) => state.movementSheet.status;
export const selectMovementSheetError = (state) => state.movementSheet.error;

export const { resetMovementSheet } = movementSheetSlice.actions;

export default movementSheetSlice.reducer;
